export { default as GoldCoin } from './GoldCoin'
export { default as Scales02 } from './Scales02'
